import React from "react";
import { useParams } from "react-router-dom";
import Student911TopMenu from "../studentInfo/student911topmenu"
import GlobalTranskript from "../../student/transkript/globaltranskript";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentTranskriptEdit() {
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
    <Student911TopMenu slug={slug} activeMenu={"Transkript"} />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <GlobalTranskript slug={slug} />            
          </div>
        </div>
      </div>
    </>
  );
}
